import find from 'lodash/find'
import {stringEnum} from '@freckle/parser'

export type IdentityProviderT = 'clever' | 'csv' | 'class-link' | 'renaissance'
export const IdentityProvider = {
  all: () => [
    IdentityProvider.Clever,
    IdentityProvider.CSV,
    IdentityProvider.ClassLink,
    IdentityProvider.Renaissance
  ],
  Clever: 'clever' as IdentityProviderT,
  CSV: 'csv' as IdentityProviderT,
  ClassLink: 'class-link' as IdentityProviderT,
  Renaissance: 'renaissance' as IdentityProviderT
}

const parse = (s: string): IdentityProviderT | undefined | null =>
  find(IdentityProvider.all(), role => s === role) || null

export const parser = stringEnum<IdentityProviderT | undefined | null>('IdentityProviderT', parse)
